export default "/images/vsetkanityt.png?93178a298ac3eec2025355d811ec1b2e";